import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Table from "../../../component/table";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import { useFormik, FieldArray, FormikProvider, Form } from "formik";
import * as Yup from "yup";
import Select, { components } from "react-select";
import Loader from "react-spinner-loader";
import Loading from "../Loader";
import "../../../css/theme.css";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../../component/modal-popup/customeModal";
import { useDispatch, useSelector } from "react-redux";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import update from "immutability-helper";
import { reminderTimeDropdownOptions } from "../../../utils";

//Importing actions
import {
  RESET_SAVE_TEMPORARY_DATA,
  SAVE_TEMPORARY_DATA,
  RESET_REDUX_STATE,
  RESET_TODO_PERFORMANCE,
  SET_PREVIOUS_PATH,
} from "../../../redux/constants/index";
import {
  getAssignmentActivityList,
  getEmbeddedAssignmentActivityList,
  getAssignmentData,
  createUpdateActivityAssignmentMapping,
  handelDeleteAssignmentMappingData,
  getAssignmentDataByConfigurationId,
} from "../../../redux/actions/assignmentAction";
import {
  getActivityConfigurationSettingMapping,
  getConfigurationData,
} from "../../../redux/actions/configurationAction";
import {
  getCollaboratorByCompany,
  getUserListDepartmentWise,
} from "../../../redux/actions/user";
import { getDepartment, getDeptWithUserAndCollaborators } from "../../../redux/actions/department";
import { getStakeholderList } from "../../../redux/actions/stakeholder";
import { useParams } from "react-router-dom";
import { TableRow } from "./TableRow";
import {
  Collaborator,
  Customer,
  Stakeholder,
} from "../../../constant/AuthenticationConstant";
import Tippy from "@tippyjs/react";
import { getWorkingHours } from "../../../redux/actions/company";

const { MenuList } = components;

export const AssignmentTodo = (props) => {
  const {
    assignmentID,
    company_id,
    saveData,
    tempPageName,
    isEmbedded = false,
  } = props;

  const [toBeDeleted, setToBeDeleted] = useState(null);
  const [openModal, setopenModal] = useState(null);
  const [assignmentMappingID, setAssignmentMappingID] = useState();
  // Creating state to enable disable tooltip

  const deleteRow = useRef();
  const location = useLocation();
  const navigate = useNavigate();

  // Creating state to show loading bar
  const [loading, setLoading] = useState(false);

  // Create state to show loader when API taking time to fetch data
  const [apiLoader, setApiLoader] = useState(false);
  const [isError, setIsError] = useState(false);

  // Creating state for initial value
  const [assignmentActivityList, setassignmentActivityList] = useState([]);

  const [updateAssignment, setUpdateAssignment] = useState(0);

  const {
    allActivityList,
    embeddedAllActivityList,
    activityAssignmentData,
    activityAssignmentDataByConfigurationId,
  } = useSelector((state) => state.assignmentReducer);

  const activityList = !isEmbedded ? allActivityList : embeddedAllActivityList;

  /* ---------------------- Default Access Token and Company ID ---------------------- */
  const dispatch = useDispatch();
  const { id } = useParams();

  const { configurationData } = useSelector(
    (state) => state.configurationReducer
  );
  const { departmentList } = useSelector((state) => state.department);
  const { department_wise_user, collaboratorListByCompany } = useSelector(
    (state) => state.user
  );
  const { stakeholder_list } = useSelector(state => state.stakeholder);
  const { company } = useSelector(state => state.auth)

  const handleDelete = async () => {
    try {
      if (assignmentMappingID) {
        const request = {
          assignmentMappingID,
          onSuccess: () => {
            deleteRow.current?.click();
            setToBeDeleted(null);
            setopenModal(null);
          },
          onError: () => {
            swal({
              content: (
                <CustomeModal
                  type="error"
                  title="Error!"
                  content={`Something went wrong. Please try again later.`}
                />
              ),
              buttons: false,
              closeOnClickOutside: false,
              closeOnEsc: false,
            });
          },
        };
        dispatch(handelDeleteAssignmentMappingData(request));
      } else {
        deleteRow.current?.click();
        setToBeDeleted(null);
        setopenModal(null);
      }
    } catch (error) {
      swal({
        content: (
          <CustomeModal
            type="error"
            title="Error!"
            content={`Something went wrong. Please try again later.`}
          />
        ),
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });
    }
  };

  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [collabOptions, setCollabOptions] = useState([]);
  const [stakeholderOptions, setStakeholderOptions] = useState([]);
  const [activityOptions, setActivityOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [allconfigs, setAllConfigs] = useState([]);
  const [config, setConfig] = useState();
  const [isConfigChange, setIsConfigChange] = useState(false);
  const [workingHours, setWorkingHours] = useState({});
  const [deptWithUser, setDeptWithUser] = useState({});

  // Integrate get activity assignment by id
  const getActivityAssignment = async () => {
    setApiLoader(true);
    const request = {
      assignmentID,
      onSuccess: () => {
        setApiLoader(false);
      },
      onError: () => {
        setIsError(true);
        setApiLoader(false);
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Something went wrong. Please try again later.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getAssignmentData(request));
  };

  // Integrate get activity assignment by configuration id
  const getActivityAssignmentByConfigurationId = async (configurationId) => {
    setApiLoader(true);
    const request = {
      configurationId,
      onSuccess: () => {
        setApiLoader(false);
      },
      onError: () => {
        setIsError(true);
        setApiLoader(false);
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Something went wrong. Please try again later.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getAssignmentDataByConfigurationId(request));
  };

  const handleConfirmWorkflowChange = (e) => {
    setIsConfigChange(true);
    setConfig(e);
    if (e?.value) {
      getActivityAssignmentByConfigurationId(e?.value);
      getActivityConfigurationByID(e?.value);
      const request = {
        company_id: company.id,
        onSuccess: (result) => {
         if(result?.data){
          setDeptWithUser(result.data)
         }
        },
        onError: () => {
          swal({
            content: (
              <CustomeModal
                type="error"
                title="Error!"
                content={`Something went wrong. Please try again later.`}
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        },
      };
      dispatch(getDeptWithUserAndCollaborators(request));
    }
  };
  const handleConfigChange = (e) => {
    if (config) {
      if (config.value !== e.value) {
        swal({
          content: (
            <CustomeModal
              type="confirm"
              title="Do you want to change the workflow?"
              onClick={() => handleConfirmWorkflowChange(e)}
              buttonText="Change"
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      }
    } else {
      handleConfirmWorkflowChange(e);
    }
  };
  // Integrate list activity configuration to show configuration list.
  const getConfigurationList = () => {
    const request = {
      company_id,
      onError: () => {},
    };
    dispatch(getConfigurationData(request));
  };

  // Integrate list department API to show department list.
  const getDepartmentList = () => {
    dispatch(
      getDepartment((res) => {
        if (res.status === 0) {
          swal({
            content: (
              <CustomeModal type="error" title="Error!" content={res.message} />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        }
      }, company_id)
    );
  };

  // Integrate getActivity Configuration by configuration id.
  const getActivityConfigurationByID = (configuration_id) => {
    const request = {
      configuration_id: configuration_id,
      onSuccess: () => {},
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Something went wrong. Please try again later.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getActivityConfigurationSettingMapping(request));
  };

  // Get user department wise
  const getUserDepartmentwise = () => {
    const request = {
      company_id,
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Something went wrong. Please try again later.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getUserListDepartmentWise(request));
  };

  // Get collaborators/customers by company id
  const getCollaboratorByCompanyId = () => {
    const request = {
      company_id,
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Something went wrong. Please try again later.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getCollaboratorByCompany(request));
  };

  // Integrate API which will give all non-deleted and deleted activity
  const getAllActivityList = () => {
    const request = {
      company_id,
      onError: () => {
        setIsError(true);
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Something went wrong. Please try again later.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    !isEmbedded
      ? dispatch(getAssignmentActivityList(request))
      : dispatch(getEmbeddedAssignmentActivityList(request));
  };

  const createUpdateAssignmentMapping = async (payloadArr) => {
    setLoading(true);
    const request = {
      payloadArr,
      onSuccess: () => {
        setLoading(false);
        if (tempPageName === "manage assignment") {
          dispatch({ type: RESET_SAVE_TEMPORARY_DATA });
        }
        swal({
          content: (
            <CustomeModal
              type="success"
              title="Success!"
              content={`To Do assignment has been updated successfully.`}
              onClick={() => {
                if(!isEmbedded){
                  // navigate(`/booking/overview`)
                  dispatch({ type: RESET_TODO_PERFORMANCE });
                  dispatch({type: SET_PREVIOUS_PATH, payload: location.pathname.toString()})
                  navigate(`/todo/performance/${assignmentID}`); 

                }else{
                  setUpdateAssignment(updateAssignment + 1)
                }
                  
              }
              }
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
      onError: () => {
        setLoading(false);
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Something went wrong. Please try again later.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(createUpdateActivityAssignmentMapping(request));
  };

  // Integrate bulk create and update API.
  const handleSubmit = async () => {
    try {
      let allow = true;
      let checkTeamOrCollaboratorExist = true;

      const payloadArr = [];
      let payload;
      formik.values.assignmentData.map((data, index) => {
        // This is normal payload for new row.
        if (data.estimated_time === "" && !data.activitySelect?.is_immutable) {
          allow = false;
        }

        if (
          data.estimated_time &&
          !data.department_id &&
          !data.collaborator_id &&
          !data.stakeholder_category_id &&
          !data.activitySelect?.is_immutable
        ) {
          checkTeamOrCollaboratorExist = false;
        }

        const obj = {
          activity_assignment_id: data.activity_assignment_id,
          user_id:
            typeof data.user_id === "string" && data.user_id.trim()
              ? data.user_id
              : null,
          activity_id: data.activity_id,
          department_id: data.department_id ? data.department_id : null,
          sequence: index + 1,
          is_mandatory: data.is_mandatory ?? false,
          link_activity: data.link_activity,
          loop_activity: data.loop_activity,
          duration: data.duration,
          collaborator_id: data.collaborator_id ? data.collaborator_id : null,
          stakeholder_category_id: data?.stakeholder_category_id ? data.stakeholder_category_id : null,
        };
        if (data.activity_customfields_id) {
          obj.activity_customfields_id = data.activity_customfields_id;
        }
        // if activity_assignment_mapping_id is availbale
        if (data.activity_assignment_mapping_id) {
          obj.activity_assignment_mapping_id =
            data.activity_assignment_mapping_id;
        }

        // if ETA and Remember is not empty
        if (data.estimated_time || data.estimated_time === null) {
          obj.estimated_time = data.estimated_time !== null ? moment(data.estimated_time) : null;
        }
        if (data.reminder_time || data.reminder_time === null) {
          obj.reminder_time = data.reminder_time;
        }

        // if collaborator/customer type user is selected
        if (
          data.department_id === Customer ||
          data.department_id === Collaborator ||
          data.department_id === Stakeholder
        ) {
          obj.department_id = null;
        }
        if(data.status) obj['status'] = data.status;
        payloadArr.push(obj);
      });
      payload = {
        configuration_id: config?.value ?? "",
        assignment: payloadArr,
      };

      if (allow && checkTeamOrCollaboratorExist) {
        createUpdateAssignmentMapping(payload);
      } else if (!checkTeamOrCollaboratorExist) {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`To Dos with an end date but without an assigned team necessitate team allocation. Please choose the team responsible for these To Dos.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      } else {
        swal({
          content: (
            <CustomeModal
              type="confirm"
              title="Are you Sure?"
              content={`To Dos without an End Date will not be assigned to the selected users. Please enter the End Dates to assign the To Dos.`}
              onClick={() => createUpdateAssignmentMapping(payload)}
              buttonText="Confirm"
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      }
    } catch (error) {
      swal({
        content: (
          <CustomeModal
            type="error"
            title="Error!"
            content={`Something went wrong. Please try again later.`}
          />
        ),
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });
    }
  };

  useEffect(() => {
    const request = {
      onSuccess: (result) => {

        if(result.status){
          setWorkingHours(result.data);
        }

      },
      onError: (error) => {
        console.log("error", error);
      },
    };
    dispatch(getWorkingHours(request));
    dispatch({type: SET_PREVIOUS_PATH, payload: location.pathname.toString()})
  }, []);

  useEffect(() => {
    setConfig();
    if (activityAssignmentData) {
      const configuration = configurationData?.data?.find(
        (value) =>
          value.configuration_id === activityAssignmentData.configuration_id
      );
      if (configuration) {
        setConfig({
          label: configuration.configuration_name,
          value: configuration.configuration_id,
        });
      }
    }
  }, [activityAssignmentData, configurationData]);

  const getDepartmentType = (item, obj) => {
    if (item.department_id) {
      const departmentData = departmentList?.data?.find((department) => {
        return department.id === item.department_id;
      });
      if (departmentData) {
        obj.departmentSelect = {
          label: departmentData.name,
          value: departmentData.id,
        };
      }
    } else if (item.collaborator_id) {
      if (item.collaborator_id.trim()) {
        obj.collaborator_id = item.collaborator_id;
        obj.departmentSelect = {
          label: `${item.collaborator.type
            .charAt(0)
            .toUpperCase()}${item.collaborator.type.slice(1)}`,
          value: item.collaborator.type,
        };
        obj.userSelect = {
          label: item.collaborator.name,
          value: item.collaborator.collaborator_id,
        };
      }
    } else if (item?.activity?.is_assign_to_customer) {
      const customerData = collaboratorListByCompany.find((collab) => {
        return collab.collaborator_id === activityAssignmentData.customer_id;
      });
      if (customerData) {
        obj.collaborator_id = customerData.collaborator_id;
        obj.departmentSelect = {
          label: `Customer`,
          value: customerData.type,
        };
        obj.userSelect = {
          label: customerData.name,
          value: customerData.collaborator_id,
        };
      }
    } 
    
    if(item.stakeholder_category_id){
      const stakeholder = stakeholderOptions?.find(ele => ele.value === item.stakeholder_category_id)
      if(stakeholder){
        const collaborator = activityAssignmentData?.booking_stakeholders?.find(ele => ele.stakeholder_category_id === item.stakeholder_category_id);
        if(collaborator){
          obj.userSelect = {
            label: collaborator.collaborator_name,
            value: collaborator.collaborator_id
          };
          obj.collaborator_id = collaborator.collaborator_id;
        }else{
          obj.userSelect = ""
        }
        obj.department_id = null;
        obj.user_id = null;

        obj.departmentSelect = {
          ...stakeholder,
          type: Stakeholder
        };
      }
    }
  };

  useEffect(() => {
    setassignmentActivityList([]);
    const array = [];
    if (!isEmbedded && tempPageName === "manage assignment") {
      setassignmentActivityList(saveData.data);
      setConfig(saveData.configuration);
    } else {
      if (
        activityAssignmentData &&
        departmentList &&
        department_wise_user &&
        activityList
      ) {
        activityAssignmentData.activity_assignment_mappings.map((item) => {
          const obj = {
            activity_assignment_id: assignmentID,
            activity_assignment_mapping_id: item.activity_assignment_mapping_id,
            activity_id: item.activity_id,
            department_id: item.department_id,
            estimated_time: item.estimated_time
              ? moment(item.estimated_time).format("Y-MM-DD HH:mm")
              : "",
            user_id: item.user_id,
            collaborator_id: item.collaborator_id,
            stakeholder_category_id: item.stakeholder_category_id,
            reminder_time: item.reminder_time
              ? moment(item.reminder_time).format("Y-MM-DD HH:mm")
              : "",
            userSelect: !isEmbedded
              ? item.user_email
                ? {
                    label: item.user_email,
                    value: item.user_email,
                  }
                : ""
              : "",
            sequence: item.sequence,
            activitySelect: "",
            departmentSelect: "",
            user_email: !isEmbedded
              ? item.user_email
                ? item.user_email
                : ""
              : "",
            status: item.status,
            is_mandatory: item.is_mandatory,
            link_activity: item.link_activity,
            loop_activity: item.loop_activity,
            dependent_todo: item.dependent_todo,
            dependent_todo_custom_field_id: item.dependent_todo_custom_field_id,
            dependent_todo_custom_field_value: item.dependent_todo_custom_field_value,
            duration: item.duration,
            reminderTimeDropdownVal: "",
          };

          // Calculate the time difference between the end-date and reminder date.
          if (item.estimated_time && item.reminder_time) {
            const diff = reminderTimeDropdownOptions.find(
              (reminderTimeOption) =>
                reminderTimeOption.value ===
                moment(item.estimated_time).diff(
                  moment(item.reminder_time),
                  "hours"
                )
            );
            
            obj.reminderTimeDropdownVal = diff;
          }

          if (item.activity_customfields_id) {
            obj.activity_customfields_id = item.activity_customfields_id;
          }
          const activityData = activityList.find((activity) => {
            return activity.id === item.activity_id;
          });
          getDepartmentType(item, obj);
          let userData;
          if (item.user_id) {
            userData = department_wise_user.find((user) => {
              return user.id === item.user_id;
            });
          }

          if (activityData) {
            obj.activitySelect = {
              label: activityData.name,
              value: activityData.id,
              is_immutable: activityData?.master_activity?.is_immutable
            };
          }
          if (userData) {
            obj.userSelect = {
              label: userData.name,
              value: userData.id,
            };
          }
          array.push(obj);
        });
        setassignmentActivityList(array);
      }
    }
  }, [
    activityAssignmentData,
    departmentList,
    department_wise_user,
    activityList,
  ]);

  useEffect(() => {
    getActivityAssignment();
    getDepartmentList();
    getUserDepartmentwise();
    getCollaboratorByCompanyId();
    getAllActivityList();
    getConfigurationList();
    dispatch(getStakeholderList())
  }, []);

  useEffect(() => {
    if (isConfigChange && activityAssignmentDataByConfigurationId) {
      setassignmentActivityList([]);
      const array = [];
      activityAssignmentDataByConfigurationId.map((item) => {
        const obj = {
          activity_assignment_id: !isEmbedded ? id : assignmentID,
          activity_id: item.activity_id,
          department_id: item?.activity?.department,
          estimated_time: item.estimated_time
            ? moment(item.estimated_time).format("Y-MM-DD HH:mm")
            : "",
          user_id: item?.activity?.user,
          reminder_time: item.reminder_time
            ? moment(item.reminder_time).format("Y-MM-DD HH:mm")
            : "",
          userSelect: !isEmbedded
            ? item.user_email
              ? {
                  label: item.user_email,
                  value: item.user_email,
                }
              : ""
            : "",
          sequence: item.sequence,
          activitySelect: "",
          departmentSelect: "",
          user_email: !isEmbedded
            ? item.user_email
              ? item.user_email
              : ""
            : "",
          status: item.dependent_todo ? "tentative" : item.status,
          is_mandatory: item.is_mandatory,
          link_activity: item.link_activity,
          loop_activity: item.loop_activity,
          dependent_todo: item.dependent_todo,
          dependent_todo_custom_field_id: item.dependent_todo_custom_field_id,
          dependent_todo_custom_field_value: item.dependent_todo_custom_field_value,
          duration: item.duration,
          reminderTimeDropdownVal: "",
          stakeholder_category_id: item.stakeholder_category_id
        };

        // Calculate the time difference between the end-date and reminder date.
        if (item.estimated_time && item.reminder_time) {
          const diff = reminderTimeDropdownOptions.find(
            (reminderTimeOption) =>
              reminderTimeOption.value ===
              moment(item.estimated_time).diff(
                moment(item.reminder_time),
                "hours"
              )
          );
          obj.reminderTimeDropdownVal = diff;
        }

        if (item.activity_customfields_id) {
          obj.activity_customfields_id = item.activity_customfields_id;
        }
        const activityData = activityList.find((activity) => {
          return activity.id === item.activity_id;
        });

        let departmentData = item?.department_id ? deptWithUser?.departments?.find(ele => ele.value === item.department_id) : item?.activity?.assign_department;
        let userData = item?.department_id ? deptWithUser?.departments?.find(ele => ele.value === item.department_id)?.user_departments?.find(ele => ele.value === item.user_id) : item?.activity?.assign_user;
        let collaboratorId = item?.collaborator_id ? item?.collaborator_id : item?.activity?.collaborator_id;
        let stakeholderId = item?.stakeholder_category_id ? item?.stakeholder_category_id : null;
        let isAssignToCustomer = item?.activity?.is_assign_to_customer;
        
        if (activityData) {
          obj.activitySelect = {
            label: activityData.name,
            value: activityData.id,
            is_immutable: activityData?.master_activity?.is_immutable
          };
        }

        if (departmentData) {
          obj.departmentSelect = {
            label: departmentData?.label ? departmentData?.label : departmentData.name,
            value: departmentData?.value ? departmentData?.value : departmentData.id,
          };
          obj.department_id = departmentData?.value ? departmentData?.value : departmentData.id;
        }

        if (userData) {
          obj.userSelect = {
            label: userData?.label ? userData.label : userData.name,
            value: userData?.value ? userData.value : userData.id,
          };
          obj.user_id = userData?.value ? userData.value : userData.id;
        }
        
        if (activityAssignmentData?.customer_id && isAssignToCustomer) {
          obj.departmentSelect = {
            label: "Customer",
            value: Customer,
          };
          const selectedCustomer = collabOptions?.find((data) => {
            if (activityAssignmentData?.customer_id) {
              return activityAssignmentData.customer_id === data.value;
            }
          });
          obj.userSelect = selectedCustomer;
          obj.collaborator_id = selectedCustomer?.value;
        }

        if(stakeholderId){
          const selectedStakeholder = stakeholderOptions?.find((data) => stakeholderId === data.value);
          if(selectedStakeholder){
            const collaborator = activityAssignmentData?.booking_stakeholders?.find(ele => ele.stakeholder_category_id === stakeholderId);
            if(collaborator){
              obj.userSelect = {
                label: collaborator.collaborator_name,
                value: collaborator.collaborator_id
              };
              obj.collaborator_id = collaborator.collaborator_id;
            }else{
              obj.userSelect = ""
            }
            obj.department_id = null;
            obj.user_id = null;
            obj.departmentSelect = {
              ...selectedStakeholder,
              type: Stakeholder
            };
            obj.stakeholder_category_id = selectedStakeholder.value;
          }
        }

        if (collaboratorId) {
          obj.departmentSelect = {
            label: "Collaborator",
            value: Collaborator,
          };
          const selectedCollaborator = collabOptions?.find((data) => {
            return collaboratorId === data.value;
          });
          obj.userSelect = selectedCollaborator;
          obj.collaborator_id = selectedCollaborator?.value;
        }

        array.push(obj);
      });
      setassignmentActivityList(array);
    }
  }, [isConfigChange, activityAssignmentDataByConfigurationId, deptWithUser, stakeholderOptions]);

  useEffect(() => {
    if (isError || tempPageName !== "manage assignment") {
      dispatch({ type: RESET_REDUX_STATE });
    }
  }, [tempPageName, assignmentID, company_id, isError]);

  useEffect(() => {
    if (isEmbedded && updateAssignment) {
      getActivityAssignment();
    }
  }, [isEmbedded, updateAssignment]);

  useEffect(() => {
    if (activityAssignmentData && activityAssignmentData.configuration_id) {
      getActivityConfigurationByID(activityAssignmentData.configuration_id);
    }
  }, [activityAssignmentData]);

  // formik for form validation
  const validationSchema = Yup.object().shape({
    assignmentData: Yup.array().of(
      Yup.object().shape({
        activityName: Yup.string().required("This Field Is Required."),
        assignTo: Yup.string().required("This Field Is Required."),
        eta: Yup.string().required("This Field Is Required."),
        remember: Yup.string().required("This Field Is Required."),
      })
    ),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      assignmentData: assignmentActivityList,
    },
    validationSchema,
    onSubmit: async () => {},
  });

  const userArr = [];
  const activityArr = [];
  const departmentArr = [];
  const collabArr = [];
  const stakeholderArr = [];

  useEffect(() => {
    if (department_wise_user) {
      department_wise_user.map((user) => {
        const obj = {
          label: user.name,
          value: user.id,
        };
        userArr.push(obj);
      });
      setOptions(userArr);
    }
  }, [department_wise_user]);

  useEffect(() => {
    if (collaboratorListByCompany) {
      collaboratorListByCompany.map((collab) => {
        const obj = {
          label: collab.name,
          value: collab.collaborator_id,
        };
        collabArr.push(obj);
      });
      setCollabOptions(collabArr);
    }
  }, [collaboratorListByCompany]);

  useEffect(() => {
    if (stakeholder_list?.data?.length > 0) {
      stakeholder_list?.data?.forEach((stake) => {
        const obj = {
          label: stake.stakeholder_category_name,
          value: stake.stakeholder_category_id,
          type: Stakeholder
        };
        stakeholderArr.push(obj);
      });
      setStakeholderOptions(stakeholderArr);
    }
  }, [stakeholder_list]);

  useEffect(() => {
    if (isConfigChange) {
      if (activityList && activityAssignmentDataByConfigurationId) {
        activityList
          .filter(
            (item) =>
              item.deletedAt === null ||
              (item.deletedAt !== null &&
                activityAssignmentDataByConfigurationId.some(
                  (mappingData) => mappingData.activity_id === item.id
                ))
          )
          .map((activity) => {
            const obj = {
              label: activity.name,
              value: activity.id,
              is_immutable: activity?.master_activity?.is_immutable
            };
            activityArr.push(obj);
          });
        setActivityOptions(activityArr);
      }
    } else {
      if (activityList && activityAssignmentData) {
        activityList
          .filter(
            (item) =>
              item.deletedAt === null ||
              (item.deletedAt !== null &&
                activityAssignmentData.activity_assignment_mappings.some(
                  (mappingData) => mappingData.activity_id === item.id
                ))
          )
          .map((activity) => {
            const obj = {
              label: activity.name,
              value: activity.id,
              is_immutable: activity?.master_activity?.is_immutable
            };
            activityArr.push(obj);
          });
        setActivityOptions(activityArr);
      }
    }
  }, [
    activityList,
    activityAssignmentData,
    activityAssignmentDataByConfigurationId,
    isConfigChange,
  ]);

  useEffect(() => {
    if (departmentList) {
      departmentList?.data?.map((department) => {
        const obj = {
          label: department.name,
          value: department.id,
        };
        departmentArr.push(obj);
      });
      let options = [
        {
          label: "Collaborator",
          value: Collaborator,
        },
        {
          label: (
            <>
              Customer
              {!activityAssignmentData?.customer_id && (
                <Tippy content="To Do cannot be assigned to a customer because the customer was not specified when the booking was created.Please select a customer for the booking in order to assign the To Do">
                  <span className="fas fa-info-circle fill-current text-[--bg-color-500] cursor-pointer text-sm ml-2"></span>
                </Tippy>
              )}
            </>
          ),
          value: Customer,
          isDisabled:
            !activityAssignmentData?.customer_id ||
            activityAssignmentData?.customer?.deletedAt,
        },
        {
          label: "Stakeholders",
          options: stakeholderOptions
        },
        {
          label: "Internal Teams",
          options: departmentArr,
        },
      ];
      setDepartmentOptions(options);
    }
  }, [departmentList, activityAssignmentData, stakeholderOptions]);

  useEffect(() => {
    if (configurationData?.data?.length !== 0) {
      const arr = [];
      configurationData?.data?.map((item) => {
        arr.push({
          value: item.configuration_id,
          label: item.configuration_name,
        });
      });
      setAllConfigs(arr);
    }
  }, [configurationData]);

  // Delete modal pop-up
  useEffect(() => {
    if (openModal) {
      swal({
        content: (
          <CustomeModal
            type="delete"
            title="Are you sure?"
            content="All of your data will be permanently removed from our servers forever. This action cannot be undone."
            onDelete={() => handleDelete()}
            onCancel={() => {
              setToBeDeleted(null);
              setopenModal(null);
            }}
          />
        ),
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });
    }
  }, [openModal]);

  // Custome react-select component
  const CustomMenuList = ({ children, ...props }) => (
    <MenuList {...props}>
      {children}
      <div
        className="menu-list"
        onClick={(e) => {
          const payload = {
            path: location.pathname,
            tempPageName: "manage assignment",
            saveData: {
              data: formik.values.assignmentData,
              configuration: config,
            },
          };

          dispatch({ type: SAVE_TEMPORARY_DATA, payload });

          if (props.selectProps.name === "ToDoName") {
            navigate("/activity/create");
          } else if (props.selectProps.name === "TeamName") {
            navigate("/departments", { state: true });
          } else if (props.selectProps.name === Collaborator) {
            navigate("/users", { state: 2 });
          } else if (props.selectProps.name === Customer) {
            navigate("/users", { state: 3 });
          } else if (props.selectProps.name === Stakeholder) {
            navigate("/stakeholders", { state: 3 });
          }else {
            navigate("/users", { state: true });
          }
        }}
      >
        <i
          class="fa-solid fa-plus fa-xs"
          style={{ paddingRight: "2px", paddingTop: "2px" }}
        ></i>
        {props.selectProps.name === "ToDoName"
          ? "Create New To Do"
          : props.selectProps.name === "TeamName"
          ? "Create New Team"
          : props.selectProps.name === Collaborator
          ? "Create New Collaborator"
          : props.selectProps.name === Customer
          ? "Create New Customer" : props.selectProps.name === Stakeholder ? "Create New Stakeholder"
          : "Create New User"}
      </div>
    </MenuList>
  );

  // Creating state for changing payloadState when element is drag
  const [draggingState, setDraggingState] = useState();

  /*-------------------- Changing payload state when element is dragging --------------- */
  useEffect(() => {
    if (draggingState) {
      setassignmentActivityList((prev) => {
        return prev.map((item, index) => {
          if (index === 0) {
            item.link_activity = null;
            item.duration = 0;
            item.duration_type = "hours";
            item.dependent_todo = null;
            item.dependent_todo_custom_field_value = null;
            item.dependent_todo_custom_field_id = null;
          } else if (index === assignmentActivityList.length - 1) {
            item.loop_activity = null;
          } else {
            if (item.link_activity) {
              const dataIndex = assignmentActivityList.findIndex(
                (element) => element.activity_id === item.link_activity
              );
              if (dataIndex > index) {
                item.link_activity = null;
              }
            }
            if (item?.dependent_todo) {
              const dataIndex = assignmentActivityList.findIndex(
                (element) => element.activity_id.value === item.dependent_todo
              );
              if (dataIndex > index) {
                item.dependent_todo = null;
                item.dependent_todo_custom_field_value = null;
                item.dependent_todo_custom_field_id = null;
              }
            }
            if (item.loop_activity) {
              const dataIndex = assignmentActivityList.findIndex(
                (element) => element.activity_id === item.loop_activity
              );
              if (dataIndex !== -1 && dataIndex < index) {
                item.loop_activity = null;
              }
            }
          }

          return item;
        });
      });
    }
  }, [draggingState]);

  /* ---------------------------- Draggable and Droppable table row ---------------------------------- */
  const moveRow = (dragIndex, hoverIndex) => {
    const dragRecord = formik.values.assignmentData[dragIndex];
    setassignmentActivityList(
      update(formik.values.assignmentData, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragRecord],
        ],
      })
    );
    setDraggingState(dragIndex);
  };
  return (
    <div className="mt-4 sm:mx-6 lg:mx-8">
      {isEmbedded && (
        <header className="sm:flex sm:justify-between sm:items-center mb-5">
          <div className="mb-4 sm:mb-0">
            <h1 className="text-2xl md:text-3xl text-slate-800 font-bold">
              Assignment
            </h1>
          </div>
        </header>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 px-6 py-4 bg-[--bg-color-50] rounded">
        <div className="space-x-4 flex items-center">
          <h4 className="text-xl leading-5 font-bold tracking-tight">
            {activityAssignmentData?.job_id}
          </h4>
        </div>

        <div className="space-x-4 flex items-center justify-end">
          <div className="my-2 sm:my-0 sm:grow-0 grow flex space-x-2">
            {activityAssignmentData && activityList && (
              <Select
                options={allconfigs}
                menuPortalTarget={document.body}
                className={"basic-single w-60 text-sm unresetText"}
                classNames={{
                  control: (style) => {
                    return `!border !shadow-sm ${
                      style.isFocused
                        ? "!border-[--bg-color-300]"
                        : "!border-slate-200 hover:!border-gray-300"
                    }}`;
                  },
                  container: (style) => {
                    return "!h-[37.5px] !font-inter !text-sm";
                  },
                  menuList: (style) => {
                    return `!max-h-[200px]`;
                  },
                }}
                name="workflow"
                isClearable={false}
                onChange={(e) => {
                  handleConfigChange(e);
                }}
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
                placeholder="Select Workflow"
                value={config}
                isDisabled={
                  activityAssignmentData?.activity_performance_count > 0
                }
              />
            )}
          </div>
        </div>
      </div>

      <div className="overflow-x-auto">
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate onSubmit={formik.handleSubmit}>
            <FieldArray
              name="assignmentData"
              render={(arrayHelpers) => (
                <>
                  <DndProvider backend={HTML5Backend}>
                    <Table
                      heads={[
                        { headName: "", isSort: false, value: "" },
                        { headName: "Status", isSort: false, value: "" },
                        { headName: "", isSort: false, value: "" },
                        {
                          headName: "To Do Name",
                          isSort: false,
                          value: "to do name",
                        },
                        {
                          headName: "Assigned Team",
                          isSort: false,
                          value: "Assigned Team",
                        },
                        { headName: "User", isSort: false, value: "user" },
                        {
                          headName: "End Date",
                          isSort: false,
                          value: "End Date",
                        },
                        {
                          headName: "Reminder",
                          isSort: false,
                          value: "Reminder",
                        },
                        {
                          headName: "Action",
                          isSort: false,
                          value: "actions",
                        },
                      ]}
                      tClass="table-auto w-full border-separate border-spacing-y-2"
                      hClass="text-sm leading-2 tracking-tight font-semibold text-[#1E293B] bg-[--bg-color-50]"
                      bClass="text-sm"
                      thClass={`px-2 py-3 whitespace-nowrap first:text-left text-left font-semibold first:pl-4 first:rounded-l-md last:rounded-r-md max-w-1/4`}
                    >
                      {apiLoader ? (
                        <tr className="px-2 py-3 whitespace-nowrap">
                          <td colSpan={9}>
                            <div className="flex justify-center p-2 my-2 whitespace-nowrap w-full">
                              <Loader show={apiLoader} />
                            </div>
                          </td>
                        </tr>
                      ) : (
                        formik.values.assignmentData.map((row, i) => {
                          return (
                            <TableRow
                              row={row}
                              i={i}
                              moveRow={moveRow}
                              setDraggingState={setDraggingState}
                              formik={formik}
                              isEmbedded={isEmbedded}
                              activityOptions={activityOptions}
                              CustomMenuList={CustomMenuList}
                              departmentOptions={departmentOptions}
                              isLoading={isLoading}
                              // handleCreate={handleCreate}
                              options={options}
                              collabOptions={collabOptions}
                              setAssignmentMappingID={setAssignmentMappingID}
                              setToBeDeleted={setToBeDeleted}
                              setopenModal={setopenModal}
                              isConfigChange={isConfigChange}
                              tdClass={
                                "px-2 py-2 text-sm leading-4 tracking-tight first:pl-4 text-[#1E293B] text-left first:text-left bg-[--bg-color-50] first:rounded-l-md last:rounded-r-md max-w-1/4 truncate"
                              }
                              workingHours={workingHours}
                              stakeholderOptions={stakeholderOptions}
                            />
                          );
                        })
                      )}
                      <tr className="px-2 py-3 whitespace-nowrap">
                        <td colSpan={9}>
                          <div
                            className={`flex justify-end p-2 my-2 ${
                              !isEmbedded ? "whitespace-nowrap w-full" : ""
                            }`}
                          >
                            <button
                              ref={deleteRow}
                              onClick={(e) => arrayHelpers.remove(toBeDeleted)}
                              className="invisible"
                            >
                              delete
                            </button>
                            {activityAssignmentData && activityList && (
                              <button
                                className="btn-sm ml-5 !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white"
                                onClick={(e) => {
                                  arrayHelpers.push({
                                    activity_assignment_id: assignmentID,
                                    activity_id: "",
                                    department_id: "",
                                    estimated_time: "",
                                    user_id: "",
                                    reminder_time: "",
                                    userSelect: "",
                                    activitySelect: "",
                                    departmentSelect: "",
                                    user_email: "",
                                    sequence: "",
                                  });
                                }}
                              >
                                <span className={`fas fa-plus mr-2`}></span>
                                Add To Do
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    </Table>
                  </DndProvider>
                </>
              )}
            />
          </Form>
        </FormikProvider>
      </div>

      <div className="flex justify-end space-x-2 my-2">
        {!isEmbedded && (
          <button
            type="button"
            className="btn bg-white border-slate-200 hover:border-slate-300 text-slate-600"
            onClick={() => {
              if (tempPageName === "manage assignment") {
                dispatch({ type: RESET_SAVE_TEMPORARY_DATA });
              }
              navigate(`/booking/overview`);
            }}
          >
            Cancel
          </button>
        )}
        {activityAssignmentData && activityList && (
          <button
            type="button"
            className="btn !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white"
            onClick={handleSubmit}
          >
            Submit
          </button>
        )}
      </div>

      {/* Modal to show loader */}
      <Loading modalOpen={loading} />
    </div>
  );
};
